<section class="about-page">
  <div class="about-title-strip">
    <h1>{{ 'ABOUT_US' | translate }}</h1>
  </div>

  <div class="about-content" [innerHTML]="content"></div>

  <div class="about-actions">
    <button class="read-more-btn" (click)="navigateToShop()">
      {{ 'VISIT_STORE' | translate }}
    </button>
  </div>
</section>
